// removed by extract-text-webpack-plugin
module.exports = {"container":"_28J-M","content":"_2xNkw"};


//////////////////
// WEBPACK FOOTER
// ./app/components/default-desktop-layout/default-desktop-layout.scss
// module id = 1589
// module chunks = 0